import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';
import { MooringService } from 'services/mooring';
import { Validator } from 'aurelia-validation';
import { MooringBuoy } from 'models/mooring';
import { sortNumberAsc } from 'lib/helpers/sorting';

type Lines = {
  id: number;
  name: string;
  buoyId?: number;
};

export type AnchorLineBuoySelectionDialogArgs = {
  mooringId: number;
  lines: Lines[];
};

@autoinject
export class AnchorLineBuoySelectionDialog {
  protected mooringId: number = 0;
  protected lines: Lines[] = [];
  protected buoys: MooringBuoy[] = [];

  protected buoysByRows: MooringBuoy[][] = [];

  constructor(
    private mooringService: MooringService,
    private dialogController: DialogController,
    protected validator: Validator
  ) {}

  activate(args: AnchorLineBuoySelectionDialogArgs) {
    this.mooringId = args.mooringId;
    this.lines = args.lines;

    void this.getBuoys();
  }

  @AsyncErrorHandler
  protected async getBuoys() {
    const { data } = await this.mooringService.getBuoys(this.mooringId);

    // group buoys by rows.
    const grouped: { [key: number]: MooringBuoy[] } = {};

    data.forEach((buoy) => {
      const row = buoy.Row;

      if (!grouped[row]) {
        grouped[row] = [];
      }
      grouped[row].push(buoy);
    });

    this.buoysByRows = Object.values(grouped);
    for (const rows of this.buoysByRows) {
      rows.sort(sortNumberAsc('Column'));
    }
  }

  protected onBuoyChange(line: Lines, buoyId: string) {
    line.buoyId = parseInt(buoyId);
  }

  protected async onCancel() {
    await this.dialogController.cancel();
  }

  protected async onCommit() {
    await this.dialogController.ok(
      this.lines.map((line) => {
        return {
          id: line.id,
          name: line.name,
          buoyId: line.buoyId,
        };
      })
    );
  }
}
